import { Controller } from 'stimulus';

export default class extends Controller {
	initialize() {
		if (typeof (this.connectToState) === 'function') {
			this.connectToState();
		}
	}
}
